export const ENTERPRISE_BASE_PRODUCT_TYPE = "base subscription fee";
export const ORGANIZATION_SCALE_PRODUCT_TYPE = "organization scale";
export const REGIONAL_CLUSTER_PRODUCT_TYPE = "regional cluster";
export const ENTERPRISE_SUBSCRIPTION = "enterprise";

export function isSubscriptionProductType(value: unknown): boolean {
    return value === ENTERPRISE_BASE_PRODUCT_TYPE || value === ORGANIZATION_SCALE_PRODUCT_TYPE || value === REGIONAL_CLUSTER_PRODUCT_TYPE;
}

export function priceSubscriptionType(value: unknown): string {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
}
